// Mirrors Volo.Abp.TenantManagement.TenantManagementPermissions.Tenants.
export const TenantPermissions = {
  default: 'AbpTenantManagement.Tenants',
  create: 'AbpTenantManagement.Tenants.Create',
  update: 'AbpTenantManagement.Tenants.Update',
  delete: 'AbpTenantManagement.Tenants.Delete',
  manageFeatures: 'AbpTenantManagement.Tenants.ManageFeatures',
  manageConnectionStrings: 'AbpTenantManagement.Tenants.ManageConnectionStrings',
} as const;
